var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 9.37583 16.8559 9.73913 16.5864 10.0022C16.3233 10.2716 15.9598 10.4219 15.5839 10.4219H9.91928V16.0844C9.91928 16.4602 9.76889 16.8235 9.49945 17.0866C9.23627 17.3497 8.8791 17.5 8.50313 17.5C8.12716 17.5 7.76373 17.3497 7.50055 17.0866C7.23111 16.8235 7.08072 16.4602 7.08072 16.0844V10.4219H1.41614C1.04018 10.4219 0.676742 10.2716 0.413564 10.0022C0.150387 9.73913 0 9.37583 0 9C0 8.62417 0.150387 8.26713 0.413564 7.99779C0.676742 7.73471 1.04018 7.58438 1.41614 7.58438H7.08072V1.92189C7.08072 1.54606 7.23111 1.18276 7.50055 0.919676C7.76373 0.650332 8.12716 0.5 8.50313 0.5C8.8791 0.5 9.23627 0.650332 9.49945 0.919676C9.76889 1.18276 9.91928 1.54606 9.91928 1.92189V7.58438H15.5839C15.9598 7.58438 16.3233 7.73471 16.5864 7.99779C16.8559 8.26713 17 8.62417 17 9Z",
    fill: "#53B175"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.346593e9525b82f5a082bd0aeb86d4cf.svg";
export { ForwardRef as ReactComponent };